export const truncate = (str: string, qnt = 190, ending = '...') => {
  if (str.length > qnt) {
    return str.substring(0, qnt - ending.length) + ending;
  }

  return str;
};
